<template>
  <v-dialog v-model="open" persistent max-width="520">
    <v-card>
      <v-card-title class="headline">{{deleteText}}</v-card-title>
      <v-flex xs12 class="p-3" v-if="showTextarea">
        <v-textarea
          label="Powód zakończenia"
          box
          text-area
          v-model="formData.status_reason"
          data-vv-name="opis usługi"
          :error-messages="errors.collect('opis usługi')"
          browser-autocomplete="off">
        </v-textarea>
      </v-flex>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" flat @click="$emit('close'); formData = {}">Nie</v-btn>
        <v-btn color="red darken-1" flat @click="accept()">Tak</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
    export default {
      props: {
        open: Boolean,
        showTextarea: Boolean,
        deleteText: String,
      },
        name: 'ModalDelete',
      data() {
        return {
          formData: {},
        };
      },
      methods: {
        accept() {
        this.$emit('accept', this.formData);
        this.formData = {};
        },
      },
    };
</script>

<style scoped>

</style>
